// https://reacttraining.com/react-router/web/example/sidebar
// use this to render in multiple places (navbar and main content)
import About from "pages/About";
import Contact from "pages/Contact";
import Events from "pages/Events";
import Home from "pages/Home";
import Links from "pages/Links";
import PrimaryPack from "pages/PrimaryPackPage";
import PrimaryTopics from "pages/PrimaryTopicsPage";
// import Quiz from "pages/Quiz";
// import QuizReport from "pages/QuizReport";
// import Quizzes from "pages/Quizzes";
import Resources from "pages/ResourcesPage";
import SecondaryPack from "pages/SecondaryPackPage";
import SecondaryTopics from "pages/SecondaryTopicsPage";

// if `navLabel` is not `null`, the item will be shown on nav menu
const routes = [
  { navLabel: "首頁", path: "/", exact: true, children: Home },
  {
    navLabel: "教材庫",
    path: "/resources",
    exact: true,
    children: Resources,
  },
  // { navLabel: "學生工作紙", path: "/quizzes", exact: true, children: Quizzes },
  { navLabel: "活動回顧", path: "/events", exact: true, children: Events },
  { navLabel: "有用連結", path: "/links", exact: true, children: Links },
  { navLabel: "聯絡我們", path: "/contact", exact: true, children: Contact },
  { navLabel: "關於我們", path: "/about", exact: true, children: About },
  {
    navLabel: null,
    path: "/primarytopics",
    exact: true,
    children: PrimaryTopics,
  },
  {
    navLabel: null,
    path: "/secondarytopics",
    exact: true,
    children: SecondaryTopics,
  },
  {
    navLabel: null,
    path: "/primarypack",
    exact: true,
    children: PrimaryPack,
  },
  {
    navLabel: null,
    path: "/secondarypack",
    exact: true,
    children: SecondaryPack,
  },
];

export default routes;
